'use strict';

var GridToolbarSystemStatusOverbookingDirective = function GridToolbarSystemStatusOverbookingDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-overbooking.html'),
    controller: 'GridToolbarSystemStatusOverbookingController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
      scope.$on('system-status-overbooking', scope.clearModifiedCells);
    }
  };
};
GridToolbarSystemStatusOverbookingDirective.$inject = [];
module.exports = GridToolbarSystemStatusOverbookingDirective;